module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "clinic_form"
  }, [_c('div', {
    staticClass: "clinic_left"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": "clinic_field01"
    }
  }, [_vm._v("Название")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.name),
      expression: "model.name"
    }],
    attrs: {
      "type": "text",
      "id": "clinic_field01"
    },
    domProps: {
      "value": (_vm.model.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": "clinic_field011"
    }
  }, [_vm._v("Владелец")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.user_id),
      expression: "model.user_id"
    }],
    attrs: {
      "id": "clinic_field011"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "user_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.users), function(user) {
    return _c('option', {
      domProps: {
        "value": user._id
      }
    }, [_vm._v(_vm._s(user.first_name) + " " + _vm._s(user.last_name))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": "clinic_field02"
    }
  }, [_vm._v("Страна")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.country),
      expression: "model.country"
    }],
    attrs: {
      "type": "text",
      "id": "clinic_field02"
    },
    domProps: {
      "value": (_vm.model.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "country", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": "clinic_field03"
    }
  }, [_vm._v("Район")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.region),
      expression: "model.region"
    }],
    attrs: {
      "type": "text",
      "id": "clinic_field03"
    },
    domProps: {
      "value": (_vm.model.region)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "region", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": "clinic_field04"
    }
  }, [_vm._v("Город")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.city),
      expression: "model.city"
    }],
    attrs: {
      "type": "text",
      "id": "clinic_field04"
    },
    domProps: {
      "value": (_vm.model.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "city", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": "clinic_field05"
    }
  }, [_vm._v("Область")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.area),
      expression: "model.area"
    }],
    attrs: {
      "type": "text",
      "id": "clinic_field05"
    },
    domProps: {
      "value": (_vm.model.area)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "area", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": "clinic_field06"
    }
  }, [_vm._v("Улица")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.street),
      expression: "model.street"
    }],
    attrs: {
      "type": "text",
      "id": "clinic_field06"
    },
    domProps: {
      "value": (_vm.model.street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "street", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": "clinic_field07"
    }
  }, [_vm._v("Дом")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.house),
      expression: "model.house"
    }],
    attrs: {
      "type": "text",
      "id": "clinic_field07"
    },
    domProps: {
      "value": (_vm.model.house)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "house", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": "clinic_field08"
    }
  }, [_vm._v("Квартира")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.apartment),
      expression: "model.apartment"
    }],
    attrs: {
      "type": "text",
      "id": "clinic_field08"
    },
    domProps: {
      "value": (_vm.model.apartment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "apartment", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": "clinic_field09"
    }
  }, [_vm._v("Метро")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.metro),
      expression: "model.metro"
    }],
    attrs: {
      "type": "text",
      "id": "clinic_field09"
    },
    domProps: {
      "value": (_vm.model.metro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "metro", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": "clinic_field10"
    }
  }, [_vm._v("Краткое описание")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.description_little),
      expression: "model.description_little"
    }],
    attrs: {
      "type": "text",
      "id": "clinic_field10"
    },
    domProps: {
      "value": (_vm.model.description_little)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "description_little", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": "clinic_field11"
    }
  }, [_vm._v("Широта")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.latitude),
      expression: "model.latitude"
    }],
    attrs: {
      "type": "text",
      "id": "clinic_field11"
    },
    domProps: {
      "value": (_vm.model.latitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "latitude", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": "clinic_field12"
    }
  }, [_vm._v("Долгота")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.longitude),
      expression: "model.longitude"
    }],
    attrs: {
      "type": "text",
      "id": "clinic_field12"
    },
    domProps: {
      "value": (_vm.model.longitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "longitude", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": "clinic_field13"
    }
  }, [_vm._v("Тип")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.own_type),
      expression: "model.own_type"
    }],
    attrs: {
      "id": "clinic_field13"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "own_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "state"
    }
  }, [_vm._v("Государственная")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "private"
    }
  }, [_vm._v("Частная")])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": "clinic_field15"
    }
  }, [_vm._v("Тип")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.clinic_type_id),
      expression: "model.clinic_type_id"
    }],
    attrs: {
      "id": "clinic_field15"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "clinic_type_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.clinicTypes), function(type) {
    return _c('option', {
      domProps: {
        "value": type._id
      }
    }, [_vm._v(_vm._s(type.name))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": "clinic_field14"
    }
  }, [_vm._v("Статус")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.status),
      expression: "model.status"
    }],
    attrs: {
      "id": "clinic_field14"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "verified"
    }
  }, [_vm._v("Верифицированая")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "not_verified"
    }
  }, [_vm._v("Не верифицированая")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clinic_right"
  }, [_c('vue-editor', {
    model: {
      value: (_vm.model.description),
      callback: function($$v) {
        _vm.$set(_vm.model, "description", $$v)
      },
      expression: "model.description"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0555f9ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Admin panel/forms/ClinicForm.vue
// module id = 570
// module chunks = 0